import React, { useState, useRef, useEffect } from "react";
import { bg_shadow } from "constant/css";
import MerchantHelperPopup from "components/modal/merchantTicketModal";

const MerchantHelper = () => {
  const [visible, setVisible] = useState(false);
  const buttonRef = useRef(null);
  const popupRef = useRef(null);

  const togglePopup = () => setVisible(!visible);
  const closePopup = () => setVisible(false);

  // Close popup if click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        closePopup();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block">
      <button
        ref={buttonRef}
        onClick={togglePopup}
        className={`${bg_shadow} rounded-full p-3 transition`}
        title="Тусламж"
      >
        <img
          src="/helper.png"
          alt="merchant-helper"
          className="w-10 h-10 object-contain"
        />
      </button>

      {visible && <MerchantHelperPopup close={closePopup} ref={popupRef} />}
    </div>
  );
};

export default MerchantHelper;
